import { format, parseISO } from 'date-fns'
import {
  DATE_FNS_PATTERN_ISO_DAY,
  DATE_FNS_PATTERN_ISO_MONTH,
  DATE_LOCAL_NOON_SUFFIX,
} from './formats'

export function formatIsoCalendarDay(date: Date): string {
  return format(date, DATE_FNS_PATTERN_ISO_DAY)
}

export function formatIsoMonthKey(date: Date): string {
  return format(date, DATE_FNS_PATTERN_ISO_MONTH)
}

export function getTodayIsoCalendarDay(): string {
  return formatIsoCalendarDay(new Date())
}

export function parseIsoDateOrDayKey(value: string): Date {
  return parseISO(value.length > 10 ? value : `${value}${DATE_LOCAL_NOON_SUFFIX}`)
}

export function coerceIsoCalendarDay(value: string | Date | null | undefined): string {
  if (!value) {
    return ''
  }
  if (value instanceof Date) {
    return formatIsoCalendarDay(value)
  }
  if (/^\d{4}-\d{2}-\d{2}$/.test(value)) {
    return value
  }
  const parsed = new Date(value)
  if (Number.isNaN(parsed.getTime())) {
    return ''
  }
  return formatIsoCalendarDay(parsed)
}
